/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID } from './actionTypes';

import { getAcesCaseProgramsProductDeliveriesByCaseIdUtil } from './utils';

/**
 * Contains the action creator functions that update the CaseProgramsProductDeliveries slice of the store.
 *
 * @namespace CaseProgramsProductDeliveriesActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/aces_case_programs_product_deliveries/{caseId}
   *
   * @param {string} caseId.
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof CaseProgramsProductDeliveriesActions
   */
  static getAcesCaseProgramsProductDeliveriesByCaseId = (dispatch, caseId, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      getAcesCaseProgramsProductDeliveriesByCaseIdUtil.bind(null, caseId),

      GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to getAcesCaseProgramsProductDeliveriesByCaseId.
   *
   * @param {function} dispatch
   * @function
   * @memberof CaseProgramsProductDeliveriesActions
   */
  static resetGetAcesCaseProgramsProductDeliveriesByCaseIdError = dispatch => {
    ReduxUtils.resetErrorAction(
      dispatch,
      GET_ACES_CASE_PROGRAMS_PRODUCT_DELIVERIES_BY_CASE_ID.failureAction
    );
  };
}
